import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientType } from "../../models/enums/clientTypeEnum";

export interface SupplierState {
    clientType: ClientType;
    toggleLocked: boolean;
}

const initialState: SupplierState = {
    clientType: getStateFromStorage() || ClientType.Standard,
    toggleLocked: false
};

const clientSlice = createSlice({
    name: 'clientType',
    initialState,
    reducers: {
        setClientType: (state, action: PayloadAction<ClientType>) => {
            state.clientType = action.payload || ClientType.Standard;
            setStateInStorage(state.clientType);
            return state;
        },
        setClientToggleLocked: (state, action: PayloadAction<boolean>) => {
            state.toggleLocked = action.payload;
            return state;
        }
    }
});

function getStateFromStorage(): ClientType | null {
    const storedState = sessionStorage.getItem('clientType');
    return storedState ? JSON.parse(storedState) as ClientType : null;
}

function setStateInStorage(state: ClientType) {
    sessionStorage.setItem('clientType', JSON.stringify(state));
}

export const {
    setClientType,
    setClientToggleLocked
} = clientSlice.actions;

export default clientSlice.reducer;